import { render } from "./Subsidiaries.vue?vue&type=template&id=46ee01a9"
import script from "./Subsidiaries.vue?vue&type=script&lang=js"
export * from "./Subsidiaries.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\sthem\\source\\repos\\Insync\\Pamodzi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__